<template>
  <div
    class="bg-quarternary-50 flex flex-col items-center space-x-4 rounded-md p-4 sm:flex-row"
  >
    <div class="grow">
      <h1 class="font-highlight text-quarternary-800 text-2xl">
        {{ title }}
      </h1>

      <span
        v-if="description"
        class="text-text text-quarternary-800 inline-block"
      >
        {{ description }}
        <slot />
      </span>
      <slot />
    </div>
    <div v-if="to && label" class="shrink-0">
      <NuxtLink
        :to="to"
        class="bg-primary-500 text-white-500 items-center space-x-4 rounded-md px-4 py-2 text-xl"
      >
        <TIcon v-if="icon" :name="icon" />
        <span>{{ label }}</span>
      </NuxtLink>
    </div>
    <div v-else-if="label" class="shrink-0">
      <button
        class="bg-primary-500 text-white-500 flex items-center space-x-4 rounded-md px-4 py-2 text-xl"
        @click="emits('action')"
      >
        <TIcon v-if="icon" :name="icon" />
        <span>{{ label }}</span>
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import TIcon from './Icon/TIcon.vue';
import type { IconType } from './Icon/icon';

defineProps<{
  title: string;
  description?: string;
  to?: string;
  label?: string;
  icon?: IconType;
}>();
const emits = defineEmits(['action']);
</script>
